import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    /* /centers */
    getAllCenters: ["sfid"],
    getAllCentersLoading: null,
    getAllCentersSuccess: ["res"],
    getAllCentersFailure: ["error"],

    /* /centers */
    getAppointmentCenter: ["sfid"],
    getAppointmentCenterLoading: null,
    getAppointmentCenterSuccess: ["res"],
    getAppointmentCenterFailure: ["error"],

    getAlternateDonorCentersInfo: [
      "donorSfid",
      "openForDate",
      "donorZipCode",
      "setCenterDistance",
    ],
    getAlternateDonorCentersInfoLoading: null,
    getAlternateDonorCentersInfoSuccess: ["res"],
    getAlternateDonorCentersInfoFailure: ["error"],

    getDonorCenterInfo: ["donorSfid"],
    getDonorCenterInfoLoading: null,
    getDonorCenterInfoSuccess: ["res"],
    getDonorCenterInfoFailure: ["error"],

    getFavoriteCenterInfo: ["donorSfid"],
    getFavoriteCenterInfoLoading: null,
    getFavoriteCenterInfoSuccess: ["res"],
    getFavoriteCenterInfoFailure: ["error"],

    updateFavoriteCenter: ["donorSfid", "centerSfid"],
    updateFavoriteCenterLoading: null,
    updateFavoriteCenterSuccess: ["res"],
    updateFavoriteCenterFailure: ["error"],

    getCenterInfo: ["locationName", "locationState"],
    getCenterInfoLoading: null,
    getCenterInfoSuccess: ["res"],
    getCenterInfoFailure: ["error"],

    /* /centers/search-all */
    getDonorCentersAll: [
      "searchStr",
      "isDIS8Center",
      "searchType",
      "addNewDonorBonusInformation",
      "setCenterDistance",
      "isSortByDistanceFalse",
    ],
    getDonorCentersAllLoading: null,
    getDonorCentersAllSuccess: ["res"],
    getDonorCentersAllFailure: ["error"],

    getStateCenters: ["stateName"],
    getStateCentersLoading: null,
    getStateCentersSuccess: ["res"],
    getStateCentersFailure: ["error"],

    getZipcodeSearchCenters: [
      "searchStr",
      "isDIS8Center",
      "searchType",
      "defaultCenter",
      "addNewDonorBonusInformation",
      "setCenterDistance",
    ],
    getZipcodeSearchCentersLoading: null,
    getZipcodeSearchCentersSuccess: ["res"],
    getZipcodeSearchCentersFailure: ["error"],

    registerGetCenters: ["searchStr"],
    registerGetCentersClear: null,
    registerGetCentersLoading: null,
    registerGetCentersSuccess: ["res"],
    registerGetCentersFailure: ["error"],

    getAppointmentSlot: ["centerSfid", "fromDateTime", "toDateTime", "forDate"],
    getAppointmentSlotLoading: null,
    getAppointmentSlotSuccess: ["res"],
    getAppointmentSlotFailure: ["error"],

    addAppointmentSlot: ["centerId", "appointment"],
    addAppointmentSlotLoading: null,
    addAppointmentSlotSuccess: ["res"],
    addAppointmentSlotFailure: ["error"],

    getSlotsForAppointmentType: [
      "forDate",
      "fromDateTime",
      "toDateTime",
      "numberOfChildren",
      "centerSfid",
      "appointmentType",
      "rescheduleId",
      "donorSfid",
    ],
    getSlotsForAppointmentTypeLoading: null,
    getSlotsForAppointmentTypeSuccess: ["res"],
    getSlotsForAppointmentTypeFailure: ["error"],

    getSlotsForDonor: ["forDate", "fromDateTime", "toDateTime", "centerSfid"],
    getSlotsForDonorLoading: null,
    getSlotsForDonorSuccess: ["res"],
    getSlotsForDonorFailure: ["error"],

    /* NEW */

    getAppointmentReport: [
      "reportType",
      "fromDateTime",
      "toDateTime",
      "centerSfid",
      "appointmentType",
      "limit",
      "page",
    ],
    getAppointmentReportLoading: null,
    getAppointmentReportSuccess: ["res"],
    getAppointmentReportFailure: ["error"],

    downloadReport: [
      "reportType",
      "fromDateTime",
      "toDateTime",
      "centerSfid",
      "appointmentType",
      "fileType",
      "limit",
      "page",
    ],
    downloadReportLoading: null,
    downloadReportSuccess: ["res", "fileType"],
    downloadReportFailure: ["error"],

    getCenterCalendar: ["date", "center"],
    getCenterCalendarLoading: null,
    getCenterCalendarSuccess: ["res"],
    getCenterCalendarFailure: ["error"],

    getCenterSlotConfig: ["date", "center", "slotType"],
    getCenterSlotConfigLoading: null,
    getCenterSlotConfigSuccess: ["res"],
    getCenterSlotConfigFailure: ["error"],

    saveCenterSlotConfig: [
      "isMassUpdate",
      "date",
      "center",
      "slotsArray",
      "startDate",
      "endDate",
      "weekDays",
      "appointmentType",
    ],
    saveCenterSlotConfigLoading: null,
    saveCenterSlotConfigSuccess: ["res"],
    saveCenterSlotConfigFailure: ["error"],

    createApplicationUser: ["applicationUser"],
    createApplicationUserLoading: null,
    createApplicationUserSuccess: ["res"],
    createApplicationUserFailure: ["error"],

    searchApplicationUser: ["searchApplicationUser"],
    searchApplicationUserLoading: null,
    searchApplicationUserSuccess: ["res"],
    searchApplicationUserFailure: ["error"],

    getApplicationUserDetails: ["loginId"],
    getApplicationUserDetailsLoading: null,
    getApplicationUserDetailsSuccess: ["res"],
    getApplicationUserDetailsFailure: ["error"],

    editApplicationUser: ["applicationUser"],
    editApplicationUserLoading: null,
    editApplicationUserSuccess: ["res"],
    editApplicationUserFailure: ["error"],

    removeUserCenterAccess: ["userCenter"],
    removeUserCenterAccessLoading: null,
    removeUserCenterAccessSuccess: ["res"],
    removeUserCenterAccessFailure: ["error"],

    updateUserDefaultCenter: ["userCenter"],
    updateUserDefaultCenterLoading: null,
    updateUserDefaultCenterSuccess: ["res"],
    updateUserDefaultCenterFailure: ["error"],

    removeUserPortalAccess: ["applicationUser"],
    removeUserPortalAccessLoading: null,
    removeUserPortalAccessSuccess: ["res"],
    removeUserPortalAccessFailure: ["error"],

    addUserCenterAccess: ["applicationUser"],
    addUserCenterAccessLoading: null,
    addUserCenterAccessSuccess: ["res"],
    addUserCenterAccessFailure: ["error"],

    cleanCentersState: null,
  },
  { prefix: "CENTERS_" }
);

export const CentersTypes = Types;

export default Creators;
